import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Header from '../components/Header';
import ColorModeButton from '../components/ColorModeButton';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Header;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "/"
      }}>{`Design Systems Coalition`}</a></p>
    <ColorModeButton mdxType="ColorModeButton" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      